import { createRef } from "react"
import { colorMapping } from "../data/colors"
import {
  BREAKPOINT,
  CARD_VIZ_HEIGHT,
  WIRED_NAV_BAR,
  WIRED_NAV_BAR2,
} from "../data/uniqueValues"
import { pathsWithIssues } from "../data/pathsWithIssues"

export const formatQuizData = (data) => {
  return data.map((d) => ({
    qId: Number(d.qId),
    question: String(d.question),
    response: String(d.response),
    possibleResultsIds: d.possibleResultsIds.split(",").map((d) => Number(d)),
    nextQId: typeof d.nextQId === "number" ? d.nextQId : null,
  }))
}

export const formatFinalData = (rawData) => {
  const data = formatQuizData(rawData)
  const allQIds = [...new Set(data.map((d) => d.qId))]
  return allQIds.map((id) => {
    const options = data.filter((d) => d.qId === id)
    return {
      qId: id,
      text: options[0].question,
      options: options.map((option) => ({
        text: option.response,
        nextQId: option.nextQId,
        possibleResultsIds: option.possibleResultsIds,
      })),
    }
  })
}

export const formatQuestionnaireData = (
  data,
  questionData,
  qNo,
  colorIndex,
  filteredOptions
) => {
  const { qId, text: question, options } = questionData
  return [
    ...data,
    {
      qId,
      qNo,
      question,
      colors: colorMapping[colorIndex],
      qRef: createRef(),
      vizRef: createRef(),
      headingRef: createRef(),
      options: filteredOptions
        ? formatOptionsData(filteredOptions)
        : formatOptionsData(options),
      lockAnswer: false,
    },
  ]
}

const formatOptionsData = (data) =>
  data.map((d, i) => ({
    ...d,
    optionId: i,
    selected: false,
    // ref: createRef(),
  }))

export const getScrollPosition = (ref, pos = "top", type) => {
  const topPadding = 20
  let pixelPosition = 0
  if (pos === "top") {
    // Results section and quiz restart
    pixelPosition = ref.current.getBoundingClientRect().top
  } else if (pos === "bottom") {
    // Bottom of the answered question
    pixelPosition = ref.current.getBoundingClientRect().bottom
  }
  if (window.innerWidth <= BREAKPOINT) {
    return pixelPosition + window.pageYOffset - (WIRED_NAV_BAR + WIRED_NAV_BAR2)
  }
  if (type === "toFirstQ") {
    return pixelPosition + window.pageYOffset
  }
  return (
    pixelPosition +
    window.pageYOffset -
    (WIRED_NAV_BAR + WIRED_NAV_BAR2 + topPadding) -
    CARD_VIZ_HEIGHT / 2
  )
}

export const hijackPaths = (questionnarie) => {
  const userChoices = questionnarie.map((d) => {
    return {
      qId: d.qId,
      question: d.question,
      answer: d.options.filter((opt) => opt.selected)[0].text,
    }
  })

  // If the user's choice match with data in pathsWithIssues.js
  // hijack the default flow of quiz and set results
  let needsHijacking = false
  let hijackedResultId = []
  pathsWithIssues.forEach((pathWithIssue) => {
    if (pathWithIssue.data.length !== userChoices.length) return
    const userChoiceMatchesPathWithIssue = pathWithIssue.data
      .map(
        (q, i) =>
          q.qId === userChoices[i].qId &&
          q.question === userChoices[i].question &&
          q.answer === userChoices[i].answer
      )
      .every((d) => d)
    if (userChoiceMatchesPathWithIssue) {
      needsHijacking = true
      hijackedResultId = pathWithIssue.resultId
    }
    return
  })
  return {
    needsHijacking,
    resultIds: hijackedResultId,
  }
}
